import TrackOrderModule from '@/modules/product/track-order';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/track-order')({
  component: TrackOrderPage,
});

function TrackOrderPage() {
  return <TrackOrderModule />;
}
